import { render, staticRenderFns } from "./Twitter.vue?vue&type=template&id=1bd4c98f&scoped=true&"
import script from "./Twitter.vue?vue&type=script&lang=js&"
export * from "./Twitter.vue?vue&type=script&lang=js&"
import style0 from "./Twitter.vue?vue&type=style&index=0&id=1bd4c98f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4c98f",
  null
  
)

export default component.exports